import React, { useState } from 'react';
import './App.css';

function Services({ setCurrentPage }) {
  const [expandedService, setExpandedService] = useState(null);
  
  const toggleService = (index) => {
    setExpandedService(expandedService === index ? null : index);
  };

  const services = [
    {
      title: 'Home Health Consultation',
      description: 'We guide agencies in setting up and improving home health operations to meet regulatory and clinical standards. Our support ensures quality patient care and strong operational performance.',
      details: [
        'Agency setup and operational improvement guidance',
        'Regulatory and clinical standards compliance',
        'Quality patient care assurance',
        'Operational performance optimization',
        'Staff training and development programs',
        'Policy and procedure development'
      ]
    },
    {
      title: 'Hospice Care Consultation',
      description: 'We help hospice providers establish compliant, compassionate care services aligned with federal and state guidelines. Our guidance strengthens patient outcomes and agency readiness.',
      details: [
        'Compliant and compassionate care service establishment',
        'Federal and state guidelines alignment',
        'Patient outcomes strengthening',
        'Agency readiness enhancement',
        'End-of-life care protocols',
        'Family support services guidance'
      ]
    },
    {
      title: 'Home Care Consultation',
      description: 'We assist home care agencies in improving service delivery, staffing, and workflow efficiency. Our consultation ensures compliance and smooth operational growth.',
      details: [
        'Service delivery improvement',
        'Staffing optimization',
        'Workflow efficiency enhancement',
        'Compliance assurance',
        'Operational growth planning',
        'Client care coordination'
      ]
    },
    {
      title: 'Survey Readiness',
      description: 'We prepare agencies for state and federal surveys through mock audits, documentation review, and process improvements. This ensures confidence and compliance on survey day.',
      details: [
        'Mock audits and assessments',
        'Documentation review and improvement',
        'Process optimization for compliance',
        'Survey preparation training',
        'Deficiency prevention strategies',
        'Regulatory compliance monitoring'
      ]
    },
    {
      title: 'Quality Assurance',
      description: 'We develop ongoing QA programs to help agencies monitor performance, correct deficiencies, and elevate care standards. Our approach builds consistency and long-term improvement.',
      details: [
        'Ongoing QA program development',
        'Performance monitoring systems',
        'Deficiency correction protocols',
        'Care standards elevation',
        'Consistency building measures',
        'Continuous improvement processes'
      ]
    },
    {
      title: 'ADR/Appeal',
      description: 'We support agencies in responding to ADRs and managing appeals with accurate clinical and billing documentation. Our assistance increases the chances of successful claim recovery.',
      details: [
        'ADR response management',
        'Appeal process guidance',
        'Clinical documentation accuracy',
        'Billing documentation review',
        'Claim recovery optimization',
        'Denial prevention strategies'
      ]
    },
    {
      title: 'Order Management',
      description: 'We streamline the physician order process to ensure timely completion, accuracy, and proper filing. This reduces delays and risk of survey deficiencies.',
      details: [
        'Physician order process streamlining',
        'Timely completion assurance',
        'Accuracy verification systems',
        'Proper filing protocols',
        'Delay reduction strategies',
        'Survey deficiency risk mitigation'
      ]
    },
    {
      title: 'Billing Process',
      description: 'We optimize the billing workflow to reduce claim errors, improve reimbursement rates, and speed up cash flow. Our solutions help agencies maintain financial stability and efficiency.',
      details: [
        'Billing workflow optimization',
        'Claim error reduction',
        'Reimbursement rate improvement',
        'Cash flow acceleration',
        'Financial stability enhancement',
        'Revenue cycle management'
      ]
    }
  ];

  return (
    <div className="App">
      <header className="header">
        <div className="container">
          <div className="logo">
            <span className="logo-icon"><img src='./s.png' height={40}></img></span>
          </div>
          <nav className="nav">
            <a href="#home" onClick={() => setCurrentPage('home')}>Home</a>
            <a href="#about" onClick={() => setCurrentPage('about')}>About</a>
            <a href="#services" onClick={() => setCurrentPage('designs')}>Services</a>
          
            <a href="#contact" onClick={() => setCurrentPage('contact')}>Contact</a>
          </nav>
        </div>
      </header>
      
      <section className="welcome-section">
        <div className="container">
          <div className="welcome-content">
            <div className="welcome-image">
              <img src="./vertical.png" alt="Healthcare Services" />
            </div>
            <div className="welcome-text">
              <h3>Our Services</h3>
              <h2>Comprehensive Healthcare Consulting</h2>
              <div className="divider"></div>
              <p>
                ZM Consulting Services offers a complete range of healthcare consulting services designed to support agencies across the entire operational spectrum. Our CHAP-certified team provides expert guidance in Home Health, Hospice, and Home Care consultation, ensuring compliance, quality care, and operational excellence.
              </p>
              <p>
                From initial agency setup to ongoing performance optimization, we deliver tailored solutions that strengthen regulatory compliance, improve patient outcomes, and enhance operational efficiency. Our comprehensive approach covers clinical, administrative, and financial aspects of healthcare agency management.
              </p>
            </div>
          </div>
        </div>
      </section>

  

      <section className="services-cards-section">
        <div className="container">
          <h2 className="section-title">Our Service Portfolio</h2>
          <div className="services-cards-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-card-icon">
                  <svg viewBox="0 0 24 24">
                    {index === 0 && <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />}
                    {index === 1 && <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />}
                    {index === 2 && <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />}
                    {index === 3 && <><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1" ry="1"/><path d="m9 12 2 2 4-4"/></>}
                    {index === 4 && <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></>}
                    {index === 5 && <><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14,2 14,8 20,8" /></>}
                    {index === 6 && <><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" /><rect x="8" y="2" width="8" height="4" rx="1" ry="1" /></>}
                    {index === 7 && <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />}
                  </svg>
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <ul className="service-card-features">
                  {service.details.slice(0, 4).map((detail, i) => (
                    <li key={i}>{detail}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <span>Copyright © 2025 ZM Consulting Services</span>
            <span>Powered by ZM Consulting Services</span>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Services;